import { useTranslation } from "react-i18next";

import { Badge } from "@profitlens/ui/badge";
import { useEntitlements } from "@/features/auth/use-session";

/** Compact plan / trial chip used in the top bars. */
export function TrialBadge() {
  const { t } = useTranslation();
  const { isPro, isTrialing, trialDaysLeft } = useEntitlements();

  if (isTrialing) {
    return (
      <Badge variant="warning" className="whitespace-nowrap">
        {t("billing.trialDaysLeft", { count: trialDaysLeft })}
      </Badge>
    );
  }

  return (
    <Badge variant={isPro ? "default" : "secondary"} className="whitespace-nowrap">
      {isPro ? t("billing.pro") : t("billing.free")}
    </Badge>
  );
}
